
// import { useEffect, useState } from "react";
// import API_URL from "../../config/api";
// import "./request.css";

// export default function AdminDashboard() {
//   const [orders, setOrders] = useState([]);
//   const [services, setServices] = useState([]);
//   const [tab, setTab] = useState("orders");

// const fetchOrders = async () => {
//   const res = await fetch(`${API_URL}/api/orders?t=${Date.now()}`, {
//     cache: "no-store",
//     headers: {
//       "Cache-Control": "no-cache",
//     },
//   });

//   const data = await res.json();
//   setOrders(data);
// };

//   // FETCH SERVICES
//   const fetchServices = async () => {
//     const res = await fetch(`${API_URL}/api/service-requests`);
//     const data = await res.json();
//     setServices(data);
//   };

//   useEffect(() => {
//     fetchOrders();
//     fetchServices();
//   }, []);

//   // UPDATE ORDER STATUS
//   const updateOrderStatus = async (id, status) => {
//     await fetch(`${API_URL}/api/orders/${id}/status`, {
//       method: "PUT",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ status }),
//     });

//     fetchOrders();
//   };

//   // UPDATE SERVICE STATUS
//   const updateServiceStatus = async (id, status) => {
//     await fetch(`${API_URL}/api/service-requests/${id}/status`, {
//       method: "PUT",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ status }),
//     });

//     fetchServices();
//   };

//   return (
//     <div className="admin-container">
//       <h1>Order & Service Request</h1>

//       {/* Tabs */}
//       <div className="tabs">
//         <button onClick={() => setTab("orders")}>Orders</button>
//         <button onClick={() => setTab("services")}>Services</button>
//       </div>

   
//       {tab === "orders" && (
//         <div className="table-container">
//           <h2>Orders</h2>

//           <table>
//             <thead>
//               <tr>
//                 <th>Customer</th>
//                 <th>Products</th>
//                 <th>Total</th>
//                 <th>Status</th>
//                 <th>Change</th>
//               </tr>
//             </thead>

//             <tbody>
//               {orders.map((o) => (
//                 <tr key={o.id}>
                
//                <td>
//   <div>
//     <strong>{o.customerName}</strong><br />
//     <small>{o.customerEmail}</small><br />
//     <small>{o.customerPhone}</small>
//   </div>
// </td>

//                   {/* PRODUCT IMAGES */}
//                   <td>
//                     <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
//                       {o.items?.map((item, idx) => (
//                         <img
//                           key={idx}
//                           src={item.productImage}
//                           alt={item.productName}
//                           style={{
//                             width: "45px",
//                             height: "45px",
//                             objectFit: "cover",
//                             borderRadius: "6px",
//                           }}
//                         />
//                       ))}
//                     </div>
//                   </td>

//                   <td>Rs {o.total}</td>

//                   <td>{o.status}</td>

//                   <td>
//                     <select
//                       value={o.status}
//                       onChange={(e) =>
//                         updateOrderStatus(o.id, e.target.value)
//                       }
//                     >
//                       <option>Pending</option>
//                       <option>Confirmed</option>
//                       <option>Delivered</option>
//                     </select>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {tab === "services" && (
//         <div className="table-container">
//           <h2>Service Requests</h2>

//           <table>
//             <thead>
//               <tr>
//                 <th>Service</th>
//                 <th>Image</th>
//                 <th>Type</th>
//                 <th>Date</th>
//                 <th>Contact</th>
//                 <th>Status</th>
//                 <th>Change</th>
//               </tr>
//             </thead>

//             <tbody>
//               {services.map((s) => (
//                 <tr key={s.id}>
//                   <td>{s.serviceName}</td>

//                   {/* SERVICE IMAGE */}
//                   <td>
//                     {s.image && (
//                       <img
//                         src={s.image}
//                         alt={s.serviceName}
//                         style={{
//                           width: "50px",
//                           height: "50px",
//                           objectFit: "cover",
//                           borderRadius: "6px",
//                         }}
//                       />
//                     )}
//                   </td>

//                   <td>{s.type}</td>
//                   <td>{s.date}</td>
//                   <td>{s.contactNumber}</td>
//                   <td>{s.status}</td>

//                   <td>
//                     <select
//                       value={s.status}
//                       onChange={(e) =>
//                         updateServiceStatus(s.id, e.target.value)
//                       }
//                     >
//                       <option>Pending</option>
//                       <option>Confirmed</option>
//                       <option>Delivered</option>
//                     </select>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import API_URL from "../../config/api";
import "./request.css";

export default function AdminDashboard() {
  const [orders, setOrders] = useState([]);
  const [services, setServices] = useState([]);
  const [tab, setTab] = useState("orders");

  const fetchOrders = async () => {
    const res = await fetch(`${API_URL}/api/orders?t=${Date.now()}`, {
      cache: "no-store",
      headers: {
        "Cache-Control": "no-cache",
      },
    });
    const data = await res.json();
    setOrders(data);
  };

  const fetchServices = async () => {
    const res = await fetch(`${API_URL}/api/service-requests`);
    const data = await res.json();
    setServices(data);
  };

  useEffect(() => {
    fetchOrders();
    fetchServices();
  }, []);

  const updateOrderStatus = async (id, status) => {
    await fetch(`${API_URL}/api/orders/${id}/status`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    });

    fetchOrders();
  };

  const updateServiceStatus = async (id, status) => {
    await fetch(`${API_URL}/api/service-requests/${id}/status`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    });

    fetchServices();
  };

  const deleteOrder = async (id) => {
    if (!window.confirm("Delete this order?")) return;

    await fetch(`${API_URL}/api/orders/${id}`, {
      method: "DELETE",
    });

    fetchOrders();
  };

  const deleteService = async (id) => {
    if (!window.confirm("Delete this service request?")) return;

    await fetch(`${API_URL}/api/service-requests/${id}`, {
      method: "DELETE",
    });

    fetchServices();
  };

  return (
    <div className="admin-container">
      <h1>Order & Service Request</h1>

      <div className="tabs">
        <button onClick={() => setTab("orders")}>Orders</button>
        <button onClick={() => setTab("services")}>Services</button>
      </div>

      {/* ================= ORDERS ================= */}
      {tab === "orders" && (
        <div className="table-container">
          <h2>Orders</h2>

          <table>
            <thead>
              <tr>
                <th>Customer</th>
                <th>Products</th>
                <th>Total</th>
                <th>Status</th>
                <th>Change</th>
                <th>Delete</th> {/* ✅ added */}
              </tr>
            </thead>

            <tbody>
              {orders.map((o) => (
                <tr key={o._id || o.id}>
                  <td>
                    <strong>{o.customerName}</strong><br />
                    <small>{o.customerEmail}</small><br />
                    <small>{o.customerPhone}</small>
                  </td>

                  <td>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                      {o.items?.map((item, idx) => (
                        <img
                          key={idx}
                          src={item.productImage}
                          alt={item.productName}
                          style={{
                            width: "45px",
                            height: "45px",
                            objectFit: "cover",
                            borderRadius: "6px",
                          }}
                        />
                      ))}
                    </div>
                  </td>

                  <td>Rs {o.total}</td>

                  <td>{o.status}</td>

                  <td>
                    <select
                      value={o.status}
                      onChange={(e) =>
                        updateOrderStatus(o._id || o.id, e.target.value)
                      }
                    >
                      <option>Pending</option>
                      <option>Confirmed</option>
                      <option>Delivered</option>
                    </select>
                  </td>

                  {/* ✅ DELETE BUTTON */}
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => deleteOrder(o._id || o.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ================= SERVICES ================= */}
      {tab === "services" && (
        <div className="table-container">
          <h2>Service Requests</h2>

          <table>
            <thead>
              <tr>
                <th>Service</th>
                <th>Image</th>
                <th>Type</th>
                <th>Date</th>
                <th>Contact</th>
                <th>Status</th>
                <th>Change</th>
                <th>Delete</th> {/* ✅ added */}
              </tr>
            </thead>

            <tbody>
              {services.map((s) => (
                <tr key={s._id || s.id}>
                  <td>{s.serviceName}</td>

                  <td>
                    {s.image && (
                      <img
                        src={s.image}
                        alt={s.serviceName}
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                          borderRadius: "6px",
                        }}
                      />
                    )}
                  </td>

                  <td>{s.type}</td>
                  <td>{s.date}</td>
                  <td>{s.contactNumber}</td>
                  <td>{s.status}</td>

                  <td>
                    <select
                      value={s.status}
                      onChange={(e) =>
                        updateServiceStatus(s._id || s.id, e.target.value)
                      }
                    >
                      <option>Pending</option>
                      <option>Confirmed</option>
                      <option>Delivered</option>
                    </select>
                  </td>

                  {/* ✅ DELETE BUTTON */}
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => deleteService(s._id || s.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}